<template>
    <div v-if="conversation" class="sc-header--wrapper">
        <div class="sc-header">
            <button
                id="list-toggle"
                type="button"
                class="sc-toggle-button"
                @click="toggleList"
            >
                <span class="sc-toggle-title">{{ __('Select a dietitian') }}</span>
                <UserAvatar :user-info="conversation" size="sm" />

                <span class="sc-header--coach">
                    <strong>{{ conversation | fullname }}</strong>
                </span>
            </button>

            <div v-if="showConsultationDetail" class="sc-header--consultation">
                <div class="sc-consultation--info">
                    <strong>{{ __('Consultation') }}</strong>
                    <span>
                        {{
                            moment(`${consultation.start} ${consultation.date}`).format('D. MMMM H:mm')
                        }}
                    </span>
                </div>

                <!-- TODO extract svg -->
                <span>{{ conversation.name }}</span>
                <a href="/zrusit-konzultaci">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            id="icon-phone"
                            d="M10 19.9297c5.4492 0 9.9609-4.5215 9.9609-9.96095 0-5.44922-4.5214-9.9609375-9.97067-9.9609375C4.55078.0078125.0390625 4.51953.0390625 9.96875.0390625 15.4082 4.56055 19.9297 10 19.9297zm-2.54883-7.5293C5.0293 9.98828 3.48633 6.91211 5.3125 5.08594c.10742-.10742.22461-.21485.33203-.32227.55664-.52734 1.10352-.49805 1.57227.17578l1.26953 1.80664c.42969.625.33203.97657-.12695 1.46485l-.41016.43945c-.13672.13672-.07813.32227-.01953.43945.19531.35157.71289.97656 1.27929 1.54296.58594.586 1.18162 1.084 1.55272 1.2891.1367.0781.3418.0976.459-.0196l.4199-.4003c.4688-.459.8496-.5762 1.4649-.1465.8398.5957 1.3476.9472 1.8359 1.289.6152.4493.7617 1.0059.1465 1.5723-.1172.1074-.2149.2246-.3223.332-1.8164 1.8164-4.88279.2735-7.31443-2.1484z"
                            fill="#714BD8"
                        />
                    </svg>
                </a>
            </div>
        </div>

        <ul v-if="showConversationSelector && conversations.length > 1" class="sc-chat-list">
            <li
                v-for="conversationItem in conversations"
                :key="conversationItem.id"
                :class="{ active: conversation.id === conversationItem.id }"
                @click="selectConversation(conversationItem)"
            >
                <UserAvatar :user-info="conversationItem" size="sm" />
                <strong>{{ conversationItem | fullname }}</strong>
                <svg
                    v-if="consultation && consultation.coach.user_id == conversationItem.id"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        id="icon-phone"
                        d="M10 19.9297c5.4492 0 9.9609-4.5215 9.9609-9.96095 0-5.44922-4.5214-9.9609375-9.97067-9.9609375C4.55078.0078125.0390625 4.51953.0390625 9.96875.0390625 15.4082 4.56055 19.9297 10 19.9297zm-2.54883-7.5293C5.0293 9.98828 3.48633 6.91211 5.3125 5.08594c.10742-.10742.22461-.21485.33203-.32227.55664-.52734 1.10352-.49805 1.57227.17578l1.26953 1.80664c.42969.625.33203.97657-.12695 1.46485l-.41016.43945c-.13672.13672-.07813.32227-.01953.43945.19531.35157.71289.97656 1.27929 1.54296.58594.586 1.18162 1.084 1.55272 1.2891.1367.0781.3418.0976.459-.0196l.4199-.4003c.4688-.459.8496-.5762 1.4649-.1465.8398.5957 1.3476.9472 1.8359 1.289.6152.4493.7617 1.0059.1465 1.5723-.1172.1074-.2149.2246-.3223.332-1.8164 1.8164-4.88279.2735-7.31443-2.1484z"
                        fill="#714BD8"
                    />
                </svg>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: {
        consultation: {
            type: Object,
            required: false,
            default: null
        },
        conversation: {
            type: Object,
            required: true
        },
        conversations: {
            type: Array,
            required: true
        }
    },
    computed: {
        showConversationSelector() {
            return location.pathname.endsWith('/chat') || location.pathname.includes('/terapeut')
        },
        showConsultationDetail() {
            const consultation = this.consultation

            return consultation && consultation.coach.user_id === this.conversation.id
        }
    },
    mounted() {
        const chatList = $('.sc-chat-list')

        if (chatList) {
            window.addEventListener('click', function(e) {
                const $el = document.getElementById('list-toggle')
                if ($el && !$el.contains(e.target)) {
                    $('.sc-header').removeClass('open')
                }
            })
        }
    },
    methods: {
        ...mapActions({
            changeConversation: 'chat/changeConversation'
        }),
        toggleList() {
            $('.sc-header').toggleClass('open')
        },
        selectConversation(conversation) {
            this.changeConversation(conversation.id)
            this.toggleList()

            this.$emit('changeConversation', conversation)
        }
    }
}
</script>
